import { render, staticRenderFns } from "./FilePowerpointIcon.vue?vue&type=template&id=8326a8e6"
import script from "./FilePowerpointIcon.vue?vue&type=script&lang=js"
export * from "./FilePowerpointIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports